import { Autocomplete, Box, InputBase, Typography } from "@mui/material";
import { useCallback, useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppConfigsFeature } from "../../features/app-configs";

export const AircraftTypeSelect = ({ label, name, value, onChange, error, helperText, multiple = false }) => {
  const dispatch = useDispatch();
  const [aircraftTypeOptions, setAircraftTypeOptions] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const [fetching, setFetching] = useState(false);

  const updateAircraftTypeOptions = useCallback(
    async (search) => {
      setFetching(true);
      const options = await AppConfigsFeature.fetchAircraftTypes({ search })(dispatch);
      setAircraftTypeOptions(options);
      setFetching(false);
    },
    [dispatch]
  );

  useLayoutEffect(() => {
    let active = true;

    if (!initialized) {
      updateAircraftTypeOptions(value ? value.manufacturer : "").then(() => {
        if (active) {
          setInitialized(true);
        }
      });
    }

    return () => {
      active = false;
    };
  }, [dispatch, initialized, updateAircraftTypeOptions, value]);

  const handleChange = async (_, value) => {
    onChange({ target: { name, value } });
  };

  return (
    <Box sx={{ my: "0.8rem" }}>
      {label && <Typography sx={{ fontWeight: "bold", mb: "0.6rem" }}>{label}</Typography>}
      <Autocomplete
        sx={{ borderRadius: "4px", backgroundColor: "#F4F4FB", paddingRight: "1rem" }}
        onChange={handleChange}
        multiple={multiple}
        defaultValue={multiple ? [] : null}
        value={value}
        options={aircraftTypeOptions}
        loading={fetching}
        isOptionEqualToValue={(option, value) => {
          return (
            `${option.manufacturer} ${option.type} (${option.model})` ===
            `${value.manufacturer} ${value.type} (${value.model})`
          );
        }}
        getOptionLabel={(option) => {
          return `${option.manufacturer} ${option.type} (${option.model})`;
        }}
        renderOption={(props, option) => {
          return (
            <Box value={option} {...props}>
              {option.manufacturer} {option.type} ({option.model})
            </Box>
          );
        }}
        renderInput={(params) => {
          const { InputLabelProps, InputProps, ...rest } = params;
          return (
            <InputBase
              {...InputProps}
              {...rest}
              onChange={({ target }) => updateAircraftTypeOptions(target.value)}
              placeholder="Please enter the aircraft type"
              sx={{ padding: "0.44rem 0.88rem" }}
            />
          );
        }}
      />
      {helperText && (
        <Typography variant="subtitle2" sx={{ m: "0.6rem", color: error ? "red" : "black" }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};
